const zgm = {
  path: 'zgm',
  component: resolve => require(['@/pages/admin/zgmCodeAgent/zgm'], resolve),
  meta: {
    requireAuth: true
  }
}

export default zgm
